<template>
    <div style="text-align:center;margin-top:60px">
        <h1>欢迎来到垚旌供应链管理平台！</h1>
    </div>
</template>